   /*==========================================================================================================
  FILTERS
  ==========================================================================================================*/
   angular
    .module('vppApp')
    .filter("split", split);
     split.$inject = ['$sce'];
      function split(input, splitChar, splitIndex) { 
        return function(input, splitChar, splitIndex) {
            return input.split(splitChar)[splitIndex];
        };
  }; 
